module.exports = __webpack_public_path__ + "img/step_1.749f537e.png";